import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

export default function Career() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2 style={{ textAlign: "center" }}>ARCHIVE</h2>
                        <div class="clearfix"></div>
                        <div class="tender">
                          <ul>
                            <h2>
                              <i class="bi bi-arrow-right"></i>{" "}
                              <Link to="/corporate_office_tenders">
                                <span
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ➝
                                </span>{" "}
                                Corporate Office{" "}
                              </Link>
                            </h2>
                            <h2>
                              <i class="fa fa-arrow-right"> </i>{" "}
                              <Link to="/gurgaon_plant_archive">
                                <span
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ➝
                                </span>{" "}
                                Gurgaon Plant
                              </Link>
                            </h2>
                            <h2>
                              <i class="fa fa-arrow-right"> </i>{" "}
                              <Link to="/rishikesh_plant_archive">
                                <span
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ➝
                                </span>{" "}
                                Rishikesh Plant{" "}
                              </Link>
                            </h2>
                            <h2>
                              {" "}
                              <i class="fa fa-arrow-right"> </i>{" "}
                              <Link to="/chennai_plant_archive">
                                <span
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ➝
                                </span>{" "}
                                Chennai Plant{" "}
                              </Link>
                            </h2>
                            <h2>
                              <i class="fa fa-arrow-right"> </i>{" "}
                              <Link to="/odcl_plant_archive">
                                {" "}
                                <span
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ➝
                                </span>{" "}
                                ODCL Plant{" "}
                              </Link>
                            </h2>
                            <h2>
                              <i class="fa fa-arrow-right"> </i>{" "}
                              <Link to="/hyderabad_plant_archive">
                                <span
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  ➝
                                </span>{" "}
                                Hyderabad Plant{" "}
                              </Link>
                            </h2>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
